import { Link } from 'react-router-dom';
import BrandWordmark from './common/BrandWordmark';

export default function Footer() {
  return (
    <footer className="relative -mt-8 rounded-t-[2rem] border-t border-slate-200 bg-white text-slate-900 dark:border-slate-500/20 dark:bg-slate-900 dark:text-white">
      <div className="absolute inset-x-0 top-0 h-20 rounded-t-[2rem] bg-gradient-to-b from-slate-200/30 to-transparent dark:from-slate-400/10 pointer-events-none"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-5">
            <div>
              <BrandWordmark className="h-16 w-16" />
              <h3 className="mt-2 text-2xl font-bold text-slate-900 dark:text-white">Smart Financial Management</h3>
            </div>
            <p className="text-slate-600 dark:text-slate-200 leading-relaxed">
              Modern accounting software built for startups and growing businesses.
            </p>
            <div className="flex items-center gap-4 text-sm text-slate-600 dark:text-slate-200">
              <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors" aria-label="Twitter">Twitter</button>
              <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors" aria-label="LinkedIn">LinkedIn</button>
              <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors" aria-label="GitHub">GitHub</button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-800 dark:text-slate-100 mb-4">Product</h4>
            <ul className="space-y-3 text-slate-600 dark:text-slate-200">
              <li><a href="#features" className="hover:text-slate-900 dark:hover:text-white transition-colors">Features</a></li>
              <li><a href="#pricing" className="hover:text-slate-900 dark:hover:text-white transition-colors">Pricing</a></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Integrations</button></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">API</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-800 dark:text-slate-100 mb-4">Company</h4>
            <ul className="space-y-3 text-slate-600 dark:text-slate-200">
              <li><Link to="/about" className="hover:text-slate-900 dark:hover:text-white transition-colors">About</Link></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Blog</button></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Careers</button></li>
              <li><Link to="/contact" className="hover:text-slate-900 dark:hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-800 dark:text-slate-100 mb-4">Support</h4>
            <ul className="space-y-3 text-slate-600 dark:text-slate-200">
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Help Center</button></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Documentation</button></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Status</button></li>
              <li><button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors text-left">Security</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 dark:text-slate-300 text-sm">© 2026 Accurix. All rights reserved.</p>
          <div className="flex items-center gap-6 text-sm text-slate-500 dark:text-slate-300">
            <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors">Privacy Policy</button>
            <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors">Terms of Service</button>
            <button type="button" className="hover:text-slate-900 dark:hover:text-white transition-colors">Cookie Policy</button>
          </div>
        </div>
      </div>
    </footer>
  )
}
  